(function () {
    'use strict';
    var m = angular.module('common');
    m.factory('downloadDetectedEntity', ["fileDao", "modals", "entityTypes", function (fileDao, modals, entityTypes) {
        function downloadEntity(entityType, entityId, origin) {
            window.open(fileDao.downloadMatchedUrl(entityId, entityType, origin), '_blank');
        }
        return {
            download: function (entityType, entityId, origin) {
                var localEntityLabel = entityTypes.toLocal(entityType) || _(entityType.split('_')).last() || 'item';
                var noConfirm = window.localStorage.getItem('download-entity-no-confirm');
                if (noConfirm) {
                    return downloadEntity(entityType, entityId, origin);
                }
                var msg = 'Downloading this ' + localEntityLabel + ' will be recorded in the audit log. Please note that ' + 'you are downloading it at your own risk as it might infringe your local privacy regulations.';
                return modals.confirm({
                    title: 'Notice',
                    message: msg,
                    okText: 'Download',
                    remember: 'Don\'t show this message again'
                }).then(function (data) {
                    if (data.remember) {
                        window.localStorage.setItem('download-entity-no-confirm', true);
                    }
                    return downloadEntity(entityType, entityId, origin);
                });
            }
        };
    }]);
}());